import { useMutation } from '@tanstack/react-query';

import { Boards } from '@air/api';
import { reportErrorToBugsnag } from '@air/utils-error';

import { type BoardTemplate } from '~/components/Modals/BoardTemplateModal/types';
import { useAddBoardsToAllLists } from '~/utils/mutateUtils/AllBoards';

export type CreateBoardsParams = {
  workspaceId: string;
  boards: BoardTemplate[];
  parentId?: string;
};

export const useCreateBoardsMutation = () => {
  const { addBoardsToAllLists } = useAddBoardsToAllLists();

  return useMutation({
    mutationFn: async ({ workspaceId, boards, parentId }: CreateBoardsParams) => {
      const response = await Boards.create({
        workspaceId,
        boards,
        parentId,
      });

      return response;
    },

    onSuccess: async (response, { parentId }) => {
      if (response.boards && response.boards.length > 0) {
        await addBoardsToAllLists(response.boards, parentId);
      }
    },

    onError: (error, { workspaceId, boards, parentId }) => {
      reportErrorToBugsnag({
        error,
        context: 'Failed to create boards from template',
        metadata: { workspaceId, boardCount: boards.length, parentId },
      });
    },
  });
};
